export default __webpack_public_path__ + "static/media/z4.927af116.png";